import { PresentationMode } from '../../common/enums';
import { AppConfig } from '../../models/config/app-config';

export const videxDVisumConfig: AppConfig = {
  umgebung: 'VIDEX',
  visumAntragsartEnum: 'LANGFRISTIGER_AUFENTHALT',

  // Diese Property wird durch einen vom Backend abgefragten Wert überschrieben
  // (siehe cfg-mek-kurzfristiger-aufenthalt.component.ts und ap2mode.service.ts).
  // Im Backend wird der Ap2Mode durch die Datei active_visum_langfristiger_aufenthalt.cfg in %KARAF_HOME%\etc bzw.
  // %LOCALAPPDATA%\MEK\etc bestimmt (siehe VisumLangfristigerAufenthaltNonVaadinApplicationContentProvider).
  presentationMode: PresentationMode.DEFAULT,

  defaults: {
    lebensunterhaltAufenthaltsdetails: {
      abweichenderVerpflichtungsgeber: {
        art: '1'
      },
      erklaerung: {
        vorbestraftJaNein: 'nein',
        ausgewiesenJaNein: 'nein',
        krankJaNein: 'nein'
      },
      lebensunterhalt: {
        abweichenderVerpflichtungsgeber: 'nein'
      }
    },
    referenz: {
      art: '3' // die Validatoren dort werden nicht sofort gesetzt
    }
  },

  isImportActive: true, // Nur in VIDEX
  isAssistantAvailable: true, // Nur in VIDEX
  isDokumenteActive: false, // In VIDEX gibt es keine Biometrie-Erfassung
  isLichtbildActive: false, // In VIDEX gibt es keine Biometrie-Erfassung
  isFingerabdruckActive: false, // In VIDEX gibt es keine Biometrie-Erfassung
  isReisedatenActive: true,
  isLebensunterhaltAufenthaltsdetailsActive: true,
  isHasKinderActive: true,
  isZusaetzlicheAngabenActive: false
};
